import React, { useState } from "react";
import Body from "./Body";
const Attendence = () => {
  const [classRepresentativeData, setClassRepresentativeData] = useState([
    {
      _id: "a1b2c3d4",
      name: "Ayaan Rahman",
      class: "1",
      section: "A",
    },
    {
      _id: "e5f6g7h8",
      name: "Samiha Akter",
      class: "2",
      section: "B",
    },
    {
      _id: "i9j1k2l3",
      name: "Rafiul Islam",
      class: "3",
      section: "C",
    },
    {
      _id: "m4n5o6p7",
      name: "Tanzila Noor",
      class: "4",
      section: "D",
    },
    {
      _id: "q8r9s1t2",
      name: "Hasib Mahmud",
      class: "5",
      section: "E",
    },
    {
      _id: "u3v4w5x6",
      name: "Nadia Hasan",
      class: "6",
      section: "A",
    },
    {
      _id: "y7z8a9b1",
      name: "Zahin Chowdhury",
      class: "7",
      section: "B",
    },
    {
      _id: "c2d3e4f5",
      name: "Mahin Hossain",
      class: "8",
      section: "C",
    },
    {
      _id: "g6h7i8j9",
      name: "Farzana Karim",
      class: "9",
      section: "D",
    },
    {
      _id: "k1l2m3n4",
      name: "Rayhan Siddique",
      class: "10",
      section: "E",
    },
  ]);
  const [managementData, setManagementData] = useState([
    {
      _id: "1a2b3c4d",
      image: "profileImg",
      name: "Ayaan Rahman",
      profileId: "SM0523001",
      designation: "Secretary",
      percentage: "45",
    },
    {
      _id: "5e6f7g8h",
      image: "profileImg",
      name: "Samiha Akter",
      profileId: "SM0523002",
      designation: "Treasurer",
      percentage: "80",
    },
    {
      _id: "9i1j2k3l",
      image: "profileImg",
      name: "Rafiul Islam",
      profileId: "SM0523003",
      designation: "President",
      percentage: "60",
    },
    {
      _id: "m4n5o6p7",
      image: "profileImg",
      name: "Tanzila Noor",
      profileId: "SM0523004",
      designation: "Vice President",
      percentage: "70",
    },
    {
      _id: "q8r9s1t2",
      image: "profileImg",
      name: "Hasib Mahmud",
      profileId: "SM0523005",
      designation: "Coordinator",
      percentage: "55",
    },
    {
      _id: "u3v4w5x6",
      image: "profileImg",
      name: "Nadia Hasan",
      profileId: "SM0523006",
      designation: "General Member",
      percentage: "90",
    },
    {
      _id: "y7z8a9b1",
      image: "profileImg",
      name: "Zahin Chowdhury",
      profileId: "SM0523007",
      designation: "Assistant Secretary",
      percentage: "35",
    },
    {
      _id: "c2d3e4f5",
      image: "profileImg",
      name: "Mahin Hossain",
      profileId: "SM0523008",
      designation: "Event Manager",
      percentage: "75",
    },
    {
      _id: "g6h7i8j9",
      image: "profileImg",
      name: "Farzana Karim",
      profileId: "SM0523009",
      designation: "Cultural Secretary",
      percentage: "50",
    },
    {
      _id: "k1l2m3n4",
      image: "profileImg",
      name: "Rayhan Siddique",
      profileId: "SM0523010",
      designation: "Sports Secretary",
      percentage: "65",
    },
  ]);
  const [teachersProfileData, setTeachersProfileData] = useState([
    {
      name: "Toufik Alam",
      _id: "SM0523019",
      subject: "Biology",
      profile_image: "profileImg",
    },
    {
      name: "Ayesha Khan",
      _id: "SM0523020",
      subject: "Physics",
      profile_image: "profileImg",
    },
    {
      name: "Rahul Sharma",
      _id: "SM0523021",
      subject: "Chemistry",
      profile_image: "profileImg",
    },
    {
      name: "Samantha Lee",
      _id: "SM0523022",
      subject: "Mathematics",
      profile_image: "profileImg",
    },
    {
      name: "Daniel Kim",
      _id: "SM0523023",
      subject: "Computer Science",
      profile_image: "profileImg",
    },
    {
      name: "Emily Zhang",
      _id: "SM0523024",
      subject: "Biotechnology",
      profile_image: "profileImg",
    },
    {
      name: "Mohammed Ali",
      _id: "SM0523025",
      subject: "Engineering",
      profile_image: "profileImg",
    },
    {
      name: "Sophia Martinez",
      _id: "SM0523026",
      subject: "Medicine",
      profile_image: "profileImg",
    },
    {
      name: "Liam Johnson",
      _id: "SM0523027",
      subject: "Psychology",
      profile_image: "profileImg",
    },
    {
      name: "Olivia Brown",
      _id: "SM0523028",
      subject: "Economics",
      profile_image: "profileImg",
    },
    {
      name: "Ethan Wilson",
      _id: "SM0523029",
      subject: "Political Science",
      profile_image: "profileImg",
    },
    {
      name: "Isabella Davis",
      _id: "SM0523030",
      subject: "History",
      profile_image: "profileImg",
    },
    {
      name: "James Patel",
      _id: "SM0523031",
      subject: "Literature",
      profile_image: "profileImg",
    },
    {
      name: "Mia Thomas",
      _id: "SM0523032",
      subject: "Environmental Science",
      profile_image: "profileImg",
    },
    {
      name: "Noah Garcia",
      _id: "SM0523033",
      subject: "Philosophy",
      profile_image: "profileImg",
    },
  ]);
  const [staffsProfileData, setStaffsProfileData] = useState([
    {
      name: "Toufik Alam",
      _id: "SM0523019",
      working_field: "Swipper",
      profile_image: "profileImg",
    },
    {
      name: "Ayesha Khan",
      _id: "SM0523020",
      working_field: "Security",
      profile_image: "profileImg",
    },
    {
      name: "Rahul Sharma",
      _id: "SM0523021",
      working_field: "Food Staff",
      profile_image: "profileImg",
    },
    {
      name: "Samantha Lee",
      _id: "SM0523022",
      working_field: "Housekeeping",
      profile_image: "profileImg",
    },
    {
      name: "Daniel Kim",
      _id: "SM0523023",
      working_field: "Maintenance",
      profile_image: "profileImg",
    },
    {
      name: "Emily Zhang",
      _id: "SM0523024",
      working_field: "Customer Service",
      profile_image: "profileImg",
    },
    {
      name: "Mohammed Ali",
      _id: "SM0523025",
      working_field: "Technical Support",
      profile_image: "profileImg",
    },
    {
      name: "Sophia Martinez",
      _id: "SM0523026",
      working_field: "Cleaning Staff",
      profile_image: "profileImg",
    },
    {
      name: "Liam Johnson",
      _id: "SM0523027",
      working_field: "Warehouse Management",
      profile_image: "profileImg",
    },
    {
      name: "Olivia Brown",
      _id: "SM0523028",
      working_field: "Receptionist",
      profile_image: "profileImg",
    },
    {
      name: "Ethan Wilson",
      _id: "SM0523029",
      working_field: "Logistics",
      profile_image: "profileImg",
    },
    {
      name: "Isabella Davis",
      _id: "SM0523030",
      working_field: "Delivery Staff",
      profile_image: "profileImg",
    },
    {
      name: "James Patel",
      _id: "SM0523031",
      working_field: "Security Supervisor",
      profile_image: "profileImg",
    },
    {
      name: "Mia Thomas",
      _id: "SM0523032",
      working_field: "Food Preparation",
      profile_image: "profileImg",
    },
    {
      name: "Noah Garcia",
      _id: "SM0523033",
      working_field: "Emergency Response",
      profile_image: "profileImg",
    },
  ]);
  const [studentsData, setStudentsData] = useState([
    {
      name: "Toufik Alam",
      _id: "STU0523019",
      class: 10,
      section: "A",
      appeared: 95.5,
      profile_image: "profileImg",
    },
    {
      name: "Ayesha Khan",
      _id: "STU0523020",
      class: 9,
      section: "B",
      appeared: 78.0,
      profile_image: "profileImg",
    },
    {
      name: "Rahul Sharma",
      _id: "STU0523021",
      class: 11,
      section: "C",
      appeared: 88.2,
      profile_image: "profileImg",
    },
    {
      name: "Samantha Lee",
      _id: "STU0523022",
      class: 12,
      section: "A",
      appeared: 92.0,
      profile_image: "profileImg",
    },
    {
      name: "Daniel Kim",
      _id: "STU0523023",
      class: 8,
      section: "D",
      appeared: 65.4,
      profile_image: "profileImg",
    },
    {
      name: "Emily Zhang",
      _id: "STU0523024",
      class: 10,
      section: "B",
      appeared: 97.3,
      profile_image: "profileImg",
    },
    {
      name: "Mohammed Ali",
      _id: "STU0523025",
      class: 9,
      section: "A",
      appeared: 80.1,
      profile_image: "profileImg",
    },
    {
      name: "Sophia Martinez",
      _id: "STU0523026",
      class: 11,
      section: "B",
      appeared: 90.7,
      profile_image: "profileImg",
    },
    {
      name: "Liam Johnson",
      _id: "STU0523027",
      class: 12,
      section: "C",
      appeared: 72.5,
      profile_image: "profileImg",
    },
    {
      name: "Olivia Brown",
      _id: "STU0523028",
      class: 8,
      section: "A",
      appeared: 85.0,
      profile_image: "profileImg",
    },
    {
      name: "Ethan Wilson",
      _id: "STU0523029",
      class: 10,
      section: "C",
      appeared: 98.4,
      profile_image: "profileImg",
    },
    {
      name: "Isabella Davis",
      _id: "STU0523030",
      class: 9,
      section: "C",
      appeared: 74.3,
      profile_image: "profileImg",
    },
    {
      name: "James Patel",
      _id: "STU0523031",
      class: 11,
      section: "A",
      appeared: 96.0,
      profile_image: "profileImg",
    },
    {
      name: "Mia Thomas",
      _id: "STU0523032",
      class: 12,
      section: "B",
      appeared: 93.8,
      profile_image: "profileImg",
    },
    {
      name: "Noah Garcia",
      _id: "STU0523033",
      class: 8,
      section: "B",
      appeared: 69.9,
      profile_image: "profileImg",
    },
  ]);
  const [genderWaysFilter, setGenderWaysFilter] = useState();
  const _this = {
    classRepresentativeData,
    setClassRepresentativeData,
    managementData,
    setManagementData,
    teachersProfileData,
    setTeachersProfileData,
    staffsProfileData,
    setStaffsProfileData,
    studentsData,
    setStudentsData,
    genderWaysFilter,
    setGenderWaysFilter,
  };
  return <Body {..._this} />;
};

export default Attendence;
